import { makeActionCreator } from '../../config/store/utils'
import {
  getContractAssets,
  getContractServices,
  getContractOthers,
  getContractInmediate,
  getContractTime,
  getContractOtherEx
} from '../../services/charts'

export const CONTRACTDIVISIONS = 'CONTRACTDIVISIONS'
export const CONTRACTDIVISIONS_ERROR = 'CONTRACTDIVISIONS_ERROR'
export const CONTRACTDIVISIONS_SUCCESS = 'CONTRACTDIVISIONS_SUCCESS'
export const onContractDivisions = makeActionCreator(CONTRACTDIVISIONS)
export const onContractDivisionsError = makeActionCreator(CONTRACTDIVISIONS_ERROR, 'payload')
export const onContractDivisionsSuccess = makeActionCreator(CONTRACTDIVISIONS_SUCCESS, 'payload')
export const onContractDivisionsThunk = (idEntity, year) => async dispatch => {
  dispatch(onContractDivisions())

  try {
    const [resBienes, resServ, resOtherCat, resInm, resTiempo, resOtherEj] = await Promise.all([
      getContractAssets({ idEntity, year }),
      getContractServices({ idEntity, year }),
      getContractOthers({ idEntity, year }),
      getContractInmediate({ idEntity, year }),
      getContractTime({ idEntity, year }),
      getContractOtherEx({ idEntity, year })
    ])

    if (resBienes.data.success !== 'OK') {
      return dispatch(onContractDivisionsError(resBienes.data.errores))
    }

    const Assets = resBienes.data.payload.find(item => item.year === year)
    const Services = resServ.data.payload.find(item => item.year === year)
    const OtherCat = resOtherCat.data.payload.find(item => item.year === year)
    const Inm = resInm.data.payload.find(item => item.year === year)
    const Time = resTiempo.data.payload.find(item => item.year === year)
    const OtherEj = resOtherEj.data.payload.find(item => item.year === year)
    const totalCat = Assets.value + Services.value + OtherCat.value
    const totalEj = Inm.value + Time.value + OtherEj.value
    const payload = {
      Assets: { ...Assets, percentage: Math.round((Assets.value * 100) / totalCat) },
      Services: { ...Services, percentage: Math.round((Services.value * 100) / totalCat) },
      OtherCat: { ...OtherCat, percentage: Math.round((OtherCat.value * 100) / totalCat) },
      Inm: { ...Inm, percentage: Math.round((Inm.value * 100) / totalEj) },
      Time: { ...Time, percentage: Math.round((Time.value * 100) / totalEj) },
      OtherEj: { ...OtherEj, percentage: Math.round((OtherEj.value * 100) / totalEj) }
    }

    return dispatch(onContractDivisionsSuccess(payload))
  } catch (error) {
    return dispatch(onContractDivisionsError(error))
  }
}
